import { CurrencyEnum } from '@systemeio/types'
import { cents } from '@systemeio/util'
import { AffiliateSumType } from 'modules/affiliate-program/affiliate/types/affiliate-interface'

export const getChartValue = (chartValue: AffiliateSumType[CurrencyEnum]) =>
  chartValue ? chartValue : cents(0)
